// Copyright © 2024 Move Closer
import { __decorate } from "tslib";
import { Component, Inject, Prop } from 'vue-property-decorator';
import { AddonsMixin } from './AddonsMixin';
/**
 * Base mixin for list components that support addons mixed within articles
 * Provides common functionality for handling addons and merged item lists
 */
let ListWithAddonsMixin = class ListWithAddonsMixin extends AddonsMixin {
};
__decorate([
    Prop({ type: Array, required: false, default: () => [] })
], ListWithAddonsMixin.prototype, "items", void 0);
__decorate([
    Prop({ type: Object, required: false })
], ListWithAddonsMixin.prototype, "readMoreLink", void 0);
__decorate([
    Inject({ from: 'eventBus' })
], ListWithAddonsMixin.prototype, "eventBus", void 0);
__decorate([
    Prop({ type: Object, required: false, default: () => ({ showArticleTags: false }) })
], ListWithAddonsMixin.prototype, "listConfig", void 0);
ListWithAddonsMixin = __decorate([
    Component({
        name: 'ListWithAddonsMixin'
    })
], ListWithAddonsMixin);
export { ListWithAddonsMixin };
